import { render } from "./MPHDefault.vue?vue&type=template&id=d05ce1a0&scoped=true&ts=true"
import script from "./MPHDefault.vue?vue&type=script&lang=ts"
export * from "./MPHDefault.vue?vue&type=script&lang=ts"

import "./MPHDefault.vue?vue&type=style&index=0&id=d05ce1a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05ce1a0"]])

export default __exports__